import { useContext, useEffect, useState } from "react";
import Label from "../components/Label";
import PopUp from "../components/PopUp";
import { AppContext } from "../App";
import { currencyFormat, hasRemovableIngredients } from "../components/functions";
import Allergens from "../components/Allergens";
import PlusMinus from "../components/PlusMinus";
import ProductLabels from "../components/ProductLabels";
import Tags from "../components/Tags";
import CloseIcon from "../components/icons/CloseIcon";
import SubproductInfo, {
  SubproductActions,
  SubproductAllergens,
  SubproductDescription,
} from "../components/SubproductInfo";

function ProductSheet({ product, setSelectedProduct }) {
  const { cart, getTranslatedString, handleAddProduct } = useContext(AppContext);
  const [infoProduct, setInfoProduct] = useState(null);
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [selectedSubroducts, setSelectedSubroducts] = useState([]);
  const [productNotes, setProductNotes] = useState("");
  const basePrice =
    product.discounted && product.discount?.price ? parseFloat(product.discount.price) : parseFloat(product.price);
  const [total, setTotal] = useState(basePrice);

  useEffect(() => {
    setDefaultQty();
  }, []);

  useEffect(() => {
    updateTotal();
  }, [selectedVariants, selectedSubroducts]);

  const setDefaultQty = () => {
    const defaultVariants = [];
    const defaultSubproducts = [];
    for (const variants_category of product.variants_categories) {
      for (const variant of [...variants_category.variants, ...variants_category.variants2]) {
        if (variant.is_default > 0)
          defaultVariants.push({
            id: variant.id,
            qty: 1,
            variant_category_id: variants_category.id,
            price: variant.price,
          });
      }
      for (const subproduct of [...variants_category.products, ...variants_category.products2]) {
        if (subproduct.is_default > 0)
          defaultSubproducts.push({
            id: subproduct.id,
            qty: 1,
            variant_category_id: variants_category.id,
            price: subproduct.price,
          });
      }
    }
    setSelectedVariants(defaultVariants);
    setSelectedSubroducts(defaultSubproducts);
  };

  const editVariant = (id, variant_category_id, qty, price) => {
    console.log("editVariant", id, variant_category_id, qty, price);
    const newArr = [...selectedVariants];
    const el = newArr.find((el) => el.id == id && el.variant_category_id == variant_category_id);
    if (el) {
      if (qty > el.qty) {
        el.qty += 1;
        setSelectedVariants(newArr);
      } else if (el.qty > 1) {
        el.qty -= 1;
        setSelectedVariants(newArr);
      } else if (el.qty == 1) {
        const index = newArr.indexOf(el);
        if (index > -1) newArr.splice(index, 1);
        setSelectedVariants(newArr);
      }
    } else if (qty > 0)
      setSelectedVariants([
        ...newArr,
        {
          id: id,
          qty: 1,
          variant_category_id: variant_category_id,
          price: price,
        },
      ]);
  };

  const getVariantQty = (id, variant_category_id) => {
    const el = selectedVariants.find((el) => el.id == id && el.variant_category_id == variant_category_id);
    if (el) return el.qty;
    else return 0;
  };

  const editSubproduct = (id, variant_category_id, qty, price) => {
    const newArr = [...selectedSubroducts];
    const el = newArr.find((el) => el.id == id && el.variant_category_id == variant_category_id);
    if (el) {
      if (qty > el.qty) {
        el.qty += 1;
        setSelectedSubroducts(newArr);
      } else if (el.qty > 0) {
        el.qty -= 1;
        setSelectedSubroducts(newArr);
      }
    } else if (qty > 0)
      setSelectedSubroducts([
        ...newArr,
        {
          id: id,
          qty: 1,
          variant_category_id: variant_category_id,
          price: price,
        },
      ]);
  };

  const getSubproductQty = (id, variant_category_id) => {
    const el = selectedSubroducts.find((el) => el.id == id && el.variant_category_id == variant_category_id);
    if (el) return el.qty;
    else return 0;
  };

  const shouldShowPlusMinus = (variants_category, item) => {
    if (Number(variants_category?.is_ingredients) !== 1) return true;
    return Number(item?.removable ?? 1) !== 0;
  };

  const getCategoryQty = (variant_category_id) => {
    let tot = 0;
    for (const variant of selectedVariants) {
      if (variant.variant_category_id == variant_category_id) tot += variant.qty;
    }
    for (const subroduct of selectedSubroducts) {
      if (subroduct.variant_category_id == variant_category_id) tot += subroduct.qty;
    }
    return tot;
  };

  const updateTotal = () => {
    let tot = basePrice;
    for (const variant of selectedVariants) {
      tot += variant.qty * parseFloat(variant.price);
    }
    for (const subroduct of selectedSubroducts) {
      tot += subroduct.qty * parseFloat(subroduct.price);
    }
    setTotal(tot);
  };

  const handleAddProductndVariants = () => {
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
    let notes = "";
    for (const ingredient of product.ingredients) {
      const el = document.getElementById("ing-" + ingredient.id);
      if (el && !el.checked) notes += el.value + "<br>";
    }
    if (productNotes) notes += productNotes;
    console.log("notes", notes);

    for (const variant_category of product.variants_categories) {
      const el = document.getElementById("vc-" + variant_category.id);
      const errorEl = el.getElementsByClassName("error");
      if (errorEl) errorEl[0].style.display = "none";
      el.classList.remove("has-error");
      if (getCategoryQty(variant_category.id) < variant_category.min) {
        console.log("c");
        el.scrollIntoView({ behavior: "smooth" });
        if (errorEl) errorEl[0].style.display = "block";
        el.classList.add("has-error");
        return;
      }
    }

    const el = document.getElementById("product-notes");
    if (el) {
      if (product.mandatory_notes == 1 && !productNotes) {
        el.style.border = "5px solid red";
        el.scrollIntoView({ behavior: "smooth" });
        return;
      } else {
        el.style.border = "0";
      }
    }

    handleAddProduct(product, product.discounted ? 1 : 0, selectedVariants, selectedSubroducts, notes);
  };

  const handleIngredientLineClick = (ingredientId, event) => {
    if (event.target.closest("input")) return;
    const input = document.getElementById("ing-" + ingredientId);
    if (input) input.checked = !input.checked;
  };

  return (
    <>
      <PopUp className="product-sheet-popup">
        <div className="header">
          <div></div>
          <button
            onClick={() => {
              window.history.replaceState(null, "", window.location.pathname + window.location.search);
              setSelectedProduct(false);
            }}
          >
            <CloseIcon></CloseIcon>
          </button>
        </div>
        <div className="content product-sheet">
          <div className="product-sheet-top">
            {product.img && (
              <div className="product-img-box">
                <img src={product.img} className="product-img" />
              </div>
            )}
            <div className="product-sheet-top-info">
              <div className="product-meta-row">
                <ProductLabels product={product} />
                <Tags product={product} />
              </div>
              <div className="title-block">
                <h1>{getTranslatedString(product, "name")}</h1>
                {getTranslatedString(product, "description") && (
                  <div
                    className="description smoot"
                    dangerouslySetInnerHTML={{
                      __html: getTranslatedString(product, "description"),
                    }}
                  />
                )}
              </div>
              <div className="price-line">
                {currencyFormat(
                  product.discounted && product.discount?.price ? product.discount.price : product.price,
                  cart?.shop?.currency,
                )}
              </div>

              {(product.ingredients.length > 0 || product.allergens.length > 0) && (
                <div className="allergens-ingredients">
                  {product.ingredients.length > 0 && (
                    <div className="ingredients">
                      <div className="title">
                        <Label number={21} />
                      </div>
                      <div className="text-inline smoot">
                        {product.ingredients.map((ingredient, i) => (
                          <span key={i}>
                            {getTranslatedString(ingredient, "name")}
                            {i < product.ingredients.length - 1 && " · "}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                  {product.allergens.length > 0 && (
                    <div>
                      <div className="title">
                        <Label number={22} />
                      </div>
                      <div className="allergens">
                        <Allergens allergens={product.allergens} color="#000" backgroundColor="#ccc" />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {product.youtube && (
            <div className="video">
              <iframe
                width="100%"
                height="315"
                src={"https://www.youtube.com/embed/" + product.youtube}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen=""
              ></iframe>
            </div>
          )}
          {product.variants_categories.map((variants_category, i) => (
            <div key={i} id={"vc-" + variants_category.id} className="variant-category-card">
              <div className="variant-category-head">
                <div className="title">{getTranslatedString(variants_category, "name")}</div>
              </div>
              <div className="small smoot min_max">
                <Label number={19} />: {variants_category.min} - <Label number={20} />:{" "}
                {variants_category.max}
              </div>
              <div className="small error">
                <Label number={92} />
              </div>
              {variants_category.max == 1 && variants_category.force_mono == 0 ? (
                <Radio
                  variants_category={variants_category}
                  selectedVariants={selectedVariants}
                  setSelectedVariants={setSelectedVariants}
                  selectedSubroducts={selectedSubroducts}
                  setSelectedSubroducts={setSelectedSubroducts}
                  onInfo={setInfoProduct}
                />
              ) : (
                <>
                  <div className="variants-categories">
                    {variants_category.variants.map((variant, n) => (
                      <div key={n} className="variant-line">
                        {product.disabled != 1 && shouldShowPlusMinus(variants_category, variant) && (
                          <PlusMinus
                            qty={getVariantQty(variant.id, variants_category.id)}
                            onCange={(qty) =>
                              editVariant(variant.id, variants_category.id, qty, variant.price)
                            }
                            disabled={
                              variants_category.force_mono == 1
                                ? getVariantQty(variant.id, variants_category.id) >= 1
                                : getCategoryQty(variants_category.id) >= variants_category.max
                            }
                          />
                        )}
                        <div>
                          {getTranslatedString(variant, "name")}
                          {variants_category.has_price == 1 && (
                            <span>{"+" + currencyFormat(variant.price, cart?.shop?.currency)}</span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="variants-categories">
                    {variants_category.variants2.map((variant, n) => (
                      <div key={n} className="variant-line">
                        {product.disabled != 1 && shouldShowPlusMinus(variants_category, variant) && (
                          <PlusMinus
                            qty={getVariantQty(variant.id, variants_category.id)}
                            onCange={(qty) =>
                              editVariant(variant.id, variants_category.id, qty, variant.price)
                            }
                            disabled={
                              variants_category.force_mono == 1
                                ? getVariantQty(variant.id, variants_category.id) >= 1
                                : getCategoryQty(variants_category.id) >= variants_category.max
                            }
                          />
                        )}
                        <div>
                          {getTranslatedString(variant, "name")}
                          {variants_category.has_price == 1 && (
                            <span>{"+" + currencyFormat(variant.price, cart?.shop?.currency)}</span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="variants-categories">
                    {variants_category.products.map((subproduct, n) => (
                      <div key={n} className="variant-line subproduct-line">
                        {product.disabled != 1 && shouldShowPlusMinus(variants_category, subproduct) && (
                          <PlusMinus
                            qty={getSubproductQty(subproduct.id, variants_category.id)}
                            onCange={(qty) =>
                              editSubproduct(subproduct.id, variants_category.id, qty, subproduct.price)
                            }
                            disabled={
                              variants_category.force_mono == 1
                                ? getSubproductQty(subproduct.id, variants_category.id) >= 1
                                : getCategoryQty(variants_category.id) >= variants_category.max
                            }
                          />
                        )}
                        <div>
                          {getTranslatedString(subproduct, "name")}
                          <span>
                            {variants_category.has_price == 1 &&
                              "+" + currencyFormat(subproduct.price, cart?.shop?.currency)}
                          </span>
                          <SubproductDescription product={subproduct} />
                          <SubproductAllergens product={subproduct} />
                        </div>
                        <SubproductActions product={subproduct} onInfo={setInfoProduct} />
                      </div>
                    ))}
                  </div>
                  <div className="variants-categories">
                    {variants_category.products2.map((subproduct, n) => (
                      <div key={n} className="variant-line subproduct-line">
                        {product.disabled != 1 && shouldShowPlusMinus(variants_category, subproduct) && (
                          <PlusMinus
                            qty={getSubproductQty(subproduct.id, variants_category.id)}
                            onCange={(qty) =>
                              editSubproduct(subproduct.id, variants_category.id, qty, subproduct.price)
                            }
                            disabled={
                              variants_category.force_mono == 1
                                ? getSubproductQty(subproduct.id, variants_category.id) >= 1
                                : getCategoryQty(variants_category.id) >= variants_category.max
                            }
                          />
                        )}
                        <div>
                          {getTranslatedString(subproduct, "name")}
                          <span>
                            {variants_category.has_price == 1 &&
                              "+" + currencyFormat(subproduct.price, cart?.shop?.currency)}
                          </span>
                          <SubproductDescription product={subproduct} />
                          <SubproductAllergens product={subproduct} />
                        </div>
                        <SubproductActions product={subproduct} onInfo={setInfoProduct} />
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          ))}
          {hasRemovableIngredients(product) && (
            <div className="variant-category-card">
              <div className="title">
                <Label number={175} />
              </div>
              <div className="small smoot">
                <Label number={176} />
              </div>
              {product.ingredients.length > 0 && (
                <div className="removable-ingredients-grid">
                  {product.ingredients.map(
                    (ingredient, i) =>
                      ingredient.removable == 1 && (
                        <div
                          key={i}
                          className="ingredient-line"
                          onClick={(e) => handleIngredientLineClick(ingredient.id, e)}
                        >
                          <div>
                            <input
                              type="checkbox"
                              id={"ing-" + ingredient.id}
                              className="removable-checkbox"
                              defaultChecked={true}
                              value={"No " + getTranslatedString(ingredient, "name")}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                          <label
                            htmlFor={"ing-" + ingredient.id}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {getTranslatedString(ingredient, "name")}
                          </label>
                        </div>
                      ),
                  )}
                </div>
              )}
            </div>
          )}
          {product.mandatory_notes == 1 && (
            <div>
              <div className="title">
                <Label number={194} />
              </div>
              <textarea
                id="product-notes"
                value={productNotes}
                onChange={(e) => setProductNotes(e.target.value)}
              ></textarea>
            </div>
          )}
        </div>
        {product.disabled == 0 && (
          <div className="footer">
            <button className="button button-primary" onClick={handleAddProductndVariants}>
              <Label number={18} /> {" \u2022 "} {currencyFormat(total, cart?.shop?.currency)}
            </button>
          </div>
        )}
      </PopUp>
      {infoProduct && <SubproductInfo product={infoProduct} onClose={() => setInfoProduct(null)} />}
    </>
  );
}

function Radio({
  variants_category,
  selectedVariants,
  setSelectedVariants,
  selectedSubroducts,
  setSelectedSubroducts,
  onInfo,
}) {
  const { cart } = useContext(AppContext);

  const editVariants = (variant, wasChecked) => {
    const newArr = [];
    for (const selectedVariant of selectedVariants) {
      if (selectedVariant.variant_category_id != variants_category.id) newArr.push(selectedVariant);
    }
    if (!wasChecked) {
      //el.classList.add("checked");
      newArr.push({
        id: variant.id,
        qty: 1,
        variant_category_id: variants_category.id,
        price: variant.price,
      });
    }
    setSelectedVariants(newArr);
  };

  const isCheckedVariants = (variantsCategoryId, variantId) => {
    for (const selectedVariant of selectedVariants) {
      if (selectedVariant.variant_category_id == variantsCategoryId && selectedVariant.id == variantId)
        return " checked";
    }
    return "";
  };

  const isCheckedVariantsBool = (variantsCategoryId, variantId) => {
    for (const selectedVariant of selectedVariants) {
      if (selectedVariant.variant_category_id == variantsCategoryId && selectedVariant.id == variantId)
        return true;
    }
    return false;
  };

  const editSubproducts = (product, wasChecked) => {
    const newArr = [];
    for (const selectedSubroduct of selectedSubroducts) {
      if (selectedSubroduct.variant_category_id != variants_category.id) newArr.push(selectedSubroduct);
    }
    if (!wasChecked) {
      //el.classList.add("checked");
      newArr.push({
        id: product.id,
        qty: 1,
        variant_category_id: variants_category.id,
        price: product.price,
      });
    }
    setSelectedSubroducts(newArr);
  };

  const isCheckedSubproducts = (variantsCategoryId, subproductId) => {
    for (const selectedSubroduct of selectedSubroducts) {
      if (selectedSubroduct.variant_category_id == variantsCategoryId && selectedSubroduct.id == subproductId)
        return " checked";
    }
    return "";
  };

  const isCheckedSubproductsBool = (variantsCategoryId, subproductId) => {
    for (const selectedSubroduct of selectedSubroducts) {
      if (selectedSubroduct.variant_category_id == variantsCategoryId && selectedSubroduct.id == subproductId)
        return true;
    }
    return false;
  };

  return (
    <div className="variants-categories radio">
      {variants_category.variants.map((variant, i) => (
        <div
          key={"v-" + i}
          className="variant-line"
          data-id={variant.id}
          data-price={variant.price}
          onClick={() =>
            editVariants(
              variant,
              isCheckedVariantsBool(variants_category.id, variant.id),
            )
          }
        >
          <button
            id={"var-" + variants_category.id + "-" + variant.id}
            name={"var-" + variants_category.id}
            className={"radio" + isCheckedVariants(variants_category.id, variant.id)}
            onClick={(e) => {
              e.stopPropagation();
              editVariants(variant, isCheckedVariantsBool(variants_category.id, variant.id));
            }}
          />
          <div className="variant-title">
            {variant.name}
            {variants_category.has_price == 1 && (
              <span>{" +" + currencyFormat(variant.price, cart?.shop?.currency)}</span>
            )}
          </div>
        </div>
      ))}
      {variants_category.variants2.map((variant, i) => (
        <div
          key={"v2-" + i}
          className="variant-line"
          data-id={variant.id}
          data-price={variant.price}
          onClick={() =>
            editVariants(
              variant,
              isCheckedVariantsBool(variants_category.id, variant.id),
            )
          }
        >
          <button
            id={"var-" + variants_category.id + "-" + variant.id}
            name={"var-" + variants_category.id}
            className={"radio" + isCheckedVariants(variants_category.id, variant.id)}
            onClick={(e) => {
              e.stopPropagation();
              editVariants(variant, isCheckedVariantsBool(variants_category.id, variant.id));
            }}
          />
          <div className="variant-title">
            {variant.name}
            {variants_category.has_price == 1 && (
              <span>{" +" + currencyFormat(variant.price, cart?.shop?.currency)}</span>
            )}
          </div>
        </div>
      ))}
      {variants_category.products.map((subproduct, i) => (
        <div
          key={"s-" + i}
          className="variant-line subproduct"
          data-id={subproduct.id}
          data-price={subproduct.price}
          onClick={() =>
            editSubproducts(
              subproduct,
              isCheckedSubproductsBool(variants_category.id, subproduct.id),
            )
          }
        >
          <button
            id={"var-" + variants_category.id + "-" + subproduct.id}
            name={"var-" + variants_category.id}
            className={"radio" + isCheckedSubproducts(variants_category.id, subproduct.id)}
            onClick={(e) => {
              e.stopPropagation();
              editSubproducts(
                subproduct,
                isCheckedSubproductsBool(variants_category.id, subproduct.id),
              );
            }}
          />
          <div className="variant-title">
            {subproduct.name}
            {variants_category.has_price == 1 && (
              <span>{" +" + currencyFormat(subproduct.price, cart?.shop?.currency)}</span>
            )}
            <SubproductDescription product={subproduct} />
            <SubproductAllergens product={subproduct} />
          </div>
          <SubproductActions product={subproduct} onInfo={onInfo} />
        </div>
      ))}
      {variants_category.products2.map((subproduct, i) => (
        <div
          key={"s2-" + i}
          className="variant-line subproduct"
          data-id={subproduct.id}
          data-price={subproduct.price}
          onClick={() =>
            editSubproducts(
              subproduct,
              isCheckedSubproductsBool(variants_category.id, subproduct.id),
            )
          }
        >
          <button
            id={"var-" + variants_category.id + "-" + subproduct.id}
            name={"var-" + variants_category.id}
            className={"radio" + isCheckedSubproducts(variants_category.id, subproduct.id)}
            onClick={(e) => {
              e.stopPropagation();
              editSubproducts(
                subproduct,
                isCheckedSubproductsBool(variants_category.id, subproduct.id),
              );
            }}
          />
          <div className="variant-title">
            {subproduct.name}
            {variants_category.has_price == 1 && (
              <span>{" +" + currencyFormat(subproduct.price, cart?.shop?.currency)}</span>
            )}
            <SubproductDescription product={subproduct} />
            <SubproductAllergens product={subproduct} />
          </div>
          <SubproductActions product={subproduct} onInfo={onInfo} />
        </div>
      ))}
    </div>
  );
}

export default ProductSheet;
